import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Download, MessageCircle } from "lucide-react";
import { waLink } from "../../lib/catalog";

// After a booking is saved: lets the customer send the booking picture into the PetalBasket WhatsApp chat.
export const BookingSent = ({ sent }) => {
  const [file, setFile] = useState(null);
  useEffect(() => {
    if (!sent.reportUrl) return undefined;
    let alive = true;
    fetch(sent.reportUrl).then((r) => r.blob()).then((b) => {
      if (alive) setFile(new File([b], "PetalBasket-booking.jpg", { type: "image/jpeg" }));
    }).catch(() => {});
    return () => { alive = false; };
  }, [sent.reportUrl]);

  const canShare = !!file && typeof navigator !== "undefined" && navigator.canShare?.({ files: [file] });
  const text = sent.reportUrl ? `${sent.message}\n\nBooking picture: ${sent.reportUrl}` : sent.message;
  const share = async (e) => {
    if (!canShare) return;
    e.preventDefault();
    try {
      await navigator.share({ files: [file], text: sent.message });
    } catch {
      window.open(waLink(text), "_blank", "noopener");
    }
  };

  return (
    <div className="flex flex-col items-center gap-5 rounded-[28px] border border-[#25D366]/40 bg-[#330B2E]/60 px-5 py-12 text-center sm:px-8" data-testid="booking-sent">
      <CheckCircle2 size={44} className="text-[#25D366]" />
      <p className="font-display text-4xl italic text-[#F3E5AB]">Thank you, {sent.name.split(" ")[0]}!</p>
      <p className="max-w-lg text-[#E8D8C8]">
        Your booking for {sent.count} design(s) on {sent.date.split("-").reverse().join("/")} has been received. Last step: send your booking picture to us on WhatsApp so we can confirm quickly.
      </p>
      {sent.reportUrl && <img src={sent.reportUrl} alt="Your booking picture" className="w-full max-w-sm rounded-2xl ring-1 ring-[#D4AF37]/40" data-testid="booking-report-image" />}
      <div className="flex flex-wrap justify-center gap-3">
        <a href={waLink(text)} onClick={share} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3.5 text-sm font-semibold text-[#06260f] transition-transform duration-300 hover:scale-105" data-testid="booking-share-whatsapp">
          <MessageCircle size={18} /> {canShare ? "Send picture on WhatsApp" : "Send on WhatsApp"}
        </a>
        {sent.reportUrl && (
          <a href={sent.reportUrl} download="PetalBasket-booking.jpg" className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-6 py-3.5 text-sm text-[#F3E5AB]" data-testid="booking-download-picture">
            <Download size={16} /> Save picture
          </a>
        )}
      </div>
      <Link to={{ pathname: "/", hash: "collections" }} className="text-sm text-[#F3E5AB] underline-offset-4 hover:underline" data-testid="booking-sent-browse">Browse more designs</Link>
    </div>
  );
};
